import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";

let logoutTimer = null;

/**
 * Get token expiry time in milliseconds
 */
export const getTokenExpiry = token => {
  try {
    const decoded = jwtDecode(token);
    return decoded.exp * 1000;
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
};

/**
 * Check if token is expired
 */
export const isTokenExpired = token => {
  const expiryTime = getTokenExpiry(token);
  if (!expiryTime) return true;
  return Date.now() >= expiryTime;
};

/**
 * Logout user and redirect to login
 */
export const performLogout = () => {
  // Clear any existing timers
  if (logoutTimer) {
    clearTimeout(logoutTimer);
    logoutTimer = null;
  }

  // Clear storage
  window.sessionStorage.clear();
  window.localStorage.clear();

  toast.error("Your session has expired. Please login again to continue working.");

  setTimeout(() => {
    window.location.href = "/";
  }, 1000);
};

/**
 * Setup automatic logout when token expires
 */
export const setupAutoLogout = token => {
  if (logoutTimer) {
    clearTimeout(logoutTimer);
  }

  const expiryTime = getTokenExpiry(token);
  if (!expiryTime) {
    performLogout();
    return;
  }

  const timeLeft = expiryTime - Date.now();

  if (timeLeft <= 0) {
    // Token already expired
    performLogout();
  } else {
    const logoutTime = Math.max(timeLeft - 1000, 0);
    // console.log(`Auto-logout scheduled in ${Math.floor(logoutTime / 1000)} seconds`);

    logoutTimer = setTimeout(() => {
      performLogout();
    }, logoutTime);
  }
};

/**
 * Clear auto-logout timer (call this on manual logout)
 */
export const clearAutoLogout = () => {
  if (logoutTimer) {
    clearTimeout(logoutTimer);
    logoutTimer = null;
  }
};
